<template>
  <div>
    <div v-for="section in allowedSections" class="payment row m0">
      <div class="col-xs-4 row pl0">
        <img :src="section.image" alt="paypo" />
      </div>
      <p class="col-xs-8 mt0 fs13">
        {{ section.text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingPaymentSection",
  props: {
    productType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sections: [
        {
          image: "/assets/payments-logo/PayPo_logo_kolor.svg",
          text: this.$t("Buy or rent now, pay in 30 days"),
          allowedProductTypes: ["simple", "configurable"],
        },
        {
          image: "/assets/shipping-logo/logo_DHL.jpg",
          text: this.$t("Fast and safe shipping in 24 hours!"),
          allowedProductTypes: ["simple", "configurable"],
        },
        {
          image: "/assets/shipping-logo/Zabka_logo_2020.svg",
          text: this.$t("Easy return at any Zabka"),
          allowedProductTypes: ["configurable"],
        },
      ],
    };
  },
  computed: {
    allowedSections() {
      return this.sections.filter((section) =>
        section.allowedProductTypes.includes(this.productType)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  max-width: 70px;
  height: auto;
  object-fit: contain;
}
.payment {
  padding: 10px;
  &:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
}
</style>
